import { ModalContainer } from "components/ui/display/ModalContainer"
import { Input } from "components/ui/inputs/Input";
import { useEffect, useState } from "react";

export const EditNoteNameModal = ({onSubmit, onDiscard, value}) => {

    const [newNoteName, setNewNoteName] = useState('');

    useEffect(() => {
            setNewNoteName(value)
        }, [value])

    return (
        <ModalContainer
            title="Endre notatnavn"
            description="Endre navn på notatet."
            submitText="Oppdater navn"
            discardText="Forkast"
            onSubmit={() => onSubmit(newNoteName)}
            onDiscard={onDiscard}
        >
            <Input
                title="Navn på notat"
                placeholder="Notatnavn..."
                value={newNoteName}
                onChange={(e) => setNewNoteName(e.target.value)}
            />
            
        </ModalContainer>
    )
}